module.exports = __webpack_public_path__ + "static/output-55e145141d92ba5bfb8ceec664a9ead5.mp3";